module.exports = "https://s81616.cdn.ngenix.net/home-frontend/_next/static/images/img_mob-be126e2ab7c4f2ac14fca61b29480433.png";